import moment from 'moment';

export function isUserWithRecentLoginProblem(user) {
  if (!user?.last_login_error_date || !user?.error_code) return false;
  const lastLoginErrorDate = moment.utc(user.last_login_error_date);
  lastLoginErrorDate.add(1, 'days');
  return lastLoginErrorDate.toDate() > new Date();
}
